import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import { findArray } from 'helpers/utils'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import PageHeader from "components/common/PageHeader";
import Loader from 'components/general/Loader'
import Label from "components/general/Label";
import NotAvailable from 'components/common/NotAvailable'
import { RESULT_STATUS, getResultStatusAsInteger, isFinishedStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Referees from 'components/general/Referees'
//Scoreboard
import VbvScoreboard from "components/sports/vbv/views/VbvScoreboard";
//Play by play
import VbvPbp from "components/sports/vbv/views/VbvPbp";
//TeamStats
import VbvTeamStats from "components/sports/vbv/views/VbvTeamStats";


const VbvContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const queryClient = useQueryClient();
    const [periodsOrder, setPeriodsOrder] = useState()
    useEffect(() => {
        const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
        const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
        const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
        setPeriodsOrder(periodsOrder_)
        // eslint-disable-next-line
    }, [])


    //DATA
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });


    if (isError) { return <NotAvailable /> }
    if (isLoading) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }


    let tabDisabled = false;
    const resultStatus = data?.results?.status?.code;
    let score

    if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.LIVE) {
        tabDisabled = true;
    }

    let bodyMiddle
    if (data?.results) {
        bodyMiddle = <VbvScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />
    }

    let shortDescription = data?.results?.eventUnit?.shortDescription;
    let presentationGame = shortDescription;
    let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;
    if (numberGame) {
        presentationGame = <>{presentationGame} - <Label data='HeaderMatch' /> {numberGame}</>
    }

    score = <ScoreHorizontal
        data={data}
        scoreHeader={{
            left: <>{presentationGame}</>
        }}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />
    return (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
            <div className='my-5'>{score}</div>
            <Tabs id="mirs-navsport" defaultActiveKey={isFinishedStatus(resultStatus) ? `2-${mirs_rsc}` : `1-${mirs_rsc}`} className="mb-3 mirs-tab-result">
                <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='HeaderPlayByPlay' />)} disabled={tabDisabled} >
                    {data?.results?.playByPlay &&
                        <><VbvPbp data={data} periodsOrder={periodsOrder} /></>
                    }
                    <Referees data={data?.results?.officials} />
                </Tab>
                <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderTeamStatistics' />)} disabled={tabDisabled}>
                    {data?.results?.periods &&
                        <><VbvTeamStats data={data} periodsOrder={periodsOrder} /></>
                    }
                    <Referees data={data?.results?.officials} />
                </Tab>
            </Tabs>
            </div>
        </>
    );
};

export default VbvContext;
